import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { add, add_count, add_page } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";

function AddRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    // const navigate = useNavigate();
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({
        name: '',
        status: '',
        start: '',
        end: ''
    });
    
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || '',
                page: page - 1,
                rows
            };
            const response = await axios.get(`${add_page(page - 1, rows)}`, {
                headers: { token },
                params
            });
            setRequestList(response.data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    
    const fetchPageData = async () => {
        try {
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || ''
            };
            const response = await axios.get(`${add_count}`, {
                headers: { token },
                params
            });
            setRowsCount(response.data?.[0]?.total || 0);
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)) {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    
    
    // 更新申請記錄
    const saveChanges = async () => {
        try {
            const dataToSend = {
                add_id: updatedData.add_id,
                mem_id: updatedData.mem_id,
                add_on_items: updatedData.add_on_items,
                deliver: updatedData.deliver,
                address: updatedData.address,
                invoice: updatedData.invoice,
                address: updatedData.address,
                company_name: updatedData.company_name,
                company_tax: updatedData.company_tax,
                remit_name: updatedData.remit_name,
                memo: updatedData.memo || '',
                total_amount: updatedData.total_amount,
                status: updatedData.status || '審核中',
            };
    
            console.log("更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${add}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                  }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.add_id === updatedData.add_id ? response.data : req
                )
            );
    
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };

    return (
        <>
            <div className="mt100 container-fluid p-5">
                <div className="mt-2">
                    <div className="row mb-3">
                    <div className="col-md-2 mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="學生姓名"
                            value={search.name}
                            onChange={(e) => setSearch({ ...search, name: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <select
                            className="form-control"
                            value={search.status}
                            onChange={(e) => setSearch({ ...search, status: e.target.value })}
                        >
                            <option value="">全部狀態</option>
                            <option value="審核中">審核中</option>
                            <option value="完成">完成</option>
                            <option value="取消">取消</option>
                        </select>
                    </div>
                    <div className="col-md-2 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={search.start}
                            onChange={(e) => setSearch({ ...search, start: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={search.end}
                            onChange={(e) => setSearch({ ...search, end: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <button className="btn btn-primary w-100" onClick={() => {
                            setPage(1);
                            fetchPageData();
                            fetchData(1);
                        }}>
                            搜尋
                        </button>
                    </div>
                </div>
                    <table className="table table-striped border table-responsive">
                        <thead>
                            <tr>
                                <th>學生姓名</th>
                                <th>加購項目</th>
                                <th>申請狀態</th>
                                <th>寄送地址</th>
                                <th>發票</th>
                                <th>抬頭</th>
                                <th>統編</th>
                                <th>匯款時間</th>
                                <th>匯款姓名</th>
                                <th>總金額</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                        {requestList.map((request) => (
                                <tr key={request.add_id}>
                                    {editingRequest && editingRequest.add_id === request.add_id ? (
                                        <>
                                            <td colSpan={10}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="input-group input-group-sm">
                                                            <span className="input-group-text">備註</span>
                                                            <textarea
                                                                className="form-control"
                                                                rows={3}
                                                                name="memo"
                                                                value={updatedData.memo ?? ''}
                                                                onChange={handleInputChange}
                                                                placeholder="內部備註（不顯示給學生）"
                                                            />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td> <a
                                                    href={`/adm/admmemberedit/${request.mem_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {request.student_name}
                                                </a>
                                            </td>
                                            <td title={request.add_on_items_name}>
                                            {request.add_on_items_name}
                                            </td>           
                                            <td>{request.status}</td>
                                            <td title={request.address}>{request.address}</td>
                                            <td>{request.invoice}</td>
                                            <td>{request.company_name}</td>
                                            <td>{request.company_tax}</td>
                                            <td>{dateHelper(request.remit_time, "date")}</td>
                                            <td>{request.remit_name}</td>
                                            <td>{request.total_amount}</td>
                                            <td>{request.created_at?.slice(0, 10)}</td>
                                            <td>
                                            {request.memo?.split(" | ").map((line, idx) => (
                                                <div key={idx}>{line}</div>
                                            ))}
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <button className="btn btn-outline-secondary me-2" disabled={page <= 1}
                            onClick={() => {
                                setPage(prev => prev - 1);
                                fetchData(page - 1);
                            }}>
                            上一頁
                        </button>
                        <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / 50)} 頁</span>
                        <button className="btn btn-outline-secondary ms-2"
                            disabled={page >= Math.ceil(rowsCount / 50)}
                            onClick={() => {
                                setPage(prev => prev + 1);
                                fetchData(page + 1);
                            }}>
                            下一頁
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddRequest;
